import { render, staticRenderFns } from "./order-logistics-number.vue?vue&type=template&id=30c8db48&scoped=true&"
import script from "./order-logistics-number.vue?vue&type=script&lang=js&"
export * from "./order-logistics-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c8db48",
  null
  
)

export default component.exports